exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditWishListGroupForm-marginLeft-2bJsn {\r\n    margin-left: 12px;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    .EditWishListGroupForm-mobileBtn-1z1aJ {\r\n        width: 100%;\r\n    }\r\n\r\n    .EditWishListGroupForm-marginLeft-2bJsn {\r\n        margin-left: 0;\r\n        margin-top: 12px;\r\n    }\r\n}", ""]);

// exports
exports.locals = {
	"marginLeft": "EditWishListGroupForm-marginLeft-2bJsn",
	"mobileBtn": "EditWishListGroupForm-mobileBtn-1z1aJ"
};